import { defineLocalStore } from '@/utils/localStore'
import { ref } from 'vue'
import axios from '@/plugins/axios'
import { urlNoteList } from '@/utils/urls'
import { handleAsync } from 'best-modules/plugins'

export const { useLocalStore: useNotes, initLocalStore: initNotes } =
  defineLocalStore(
    'notes',
    (payload: { entityTypeId: number; entityId: number }) => {
      const { entityTypeId, entityId } = payload
      const noteList = ref<any[]>([])

      const getNoteList = () => {
        return handleAsync('noteList', () => {
          return axios.get(urlNoteList(entityTypeId, entityId)).then(res => {
            noteList.value = res.data.data
          })
        })
      }

      getNoteList()

      return { noteList, entityTypeId, entityId }
    }
  )
